import React, { FC } from 'react'
import { useScreenClass } from 'react-grid-system'
import styled from 'styled-components'
import BANNER from '../../assets/hero-banner.png'

const Section = styled.section<{ isDesktop: boolean }>`
  height: ${(props) => (props.isDesktop ? '240px' : '160px')};
  text-align: center;
  background-image: url(${BANNER});
  background-size: cover;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 2;
  margin-bottom: 0rem;

  h2 {
    font-size: ${(props) => (props.isDesktop ? '60px' : '36px')};
    letter-spacing: 2px;
    margin: 0;
    color: white;
    text-shadow: 0px 2px 6px rgba(0,0,0,0.5);
  }
`

const SecondaryHero: FC = ({ children }) => {
  const screenClass = useScreenClass()
  const isDesktop = ['lg', 'xl'].includes(screenClass)

  return (
    <Section isDesktop={isDesktop}>
      <h2>{children}</h2>
    </Section>
  )
}

export default SecondaryHero
